import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { match } from 'ts-pattern';
import commonPropTypes from '../../../constants/commonPropTypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import PendingTooltip from './pendingTooltip';
import styles from './styles.scss';
const cx = classnames.bind(styles);
class FieldLabel extends Component {
    static propTypes = {
        ...commonPropTypes,
        error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        required: PropTypes.bool,
        pendingApproval: PropTypes.bool,
    };
    static defaultProps = {
        error: false,
        required: false,
    };
    render() {
        const { className, elmId, inputName, label, error, required, optional, pendingApproval, } = this.props;
        const requiredOrOptional = match({ required, optional })
            .with({ required: true }, () => _jsx("span", { className: cx('warning'), children: " *" }))
            .with({ optional: true }, () => (_jsx("span", { children: _jsx("i", { children: " (Optional)" }) })))
            .otherwise(() => null);
        return (_jsxs("span", { children: [pendingApproval && _jsx(PendingTooltip, {}), _jsxs("label", { "data-elm-id": `${elmId}_label`, htmlFor: inputName, className: cx('label', className), children: [_jsx("span", { className: cx(error ? 'warning' : ''), children: label }), requiredOrOptional] })] }));
    }
}
export default FieldLabel;
//# sourceMappingURL=fieldLabel.js.map